import { Component, HostListener, OnDestroy, OnInit, ViewChild, ComponentFactoryResolver,Injector  } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { RentingService } from 'src/app/services/renting.service';
import { Subscription } from 'rxjs';
import { HostService } from 'src/app/services/host.service';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { InvoiceService } from 'src/app/services/invoice.service';
import { download } from './download.function';
import { RentingMessageComponent } from 'src/app/shared/renting-message/renting-message.component';
import { LocationSmartService } from 'src/app/services/location-smart.service';
import { AuthService } from 'src/app/services/auth.service';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { ChoosePaymentMethodComponent } from 'src/app/shared/choose-payment-method/choose-payment-method.component';
import { ExtensionSmartService } from 'src/app/services/extension-smart.service';
import { VerifResponsiveService } from 'src/app/services/verif-responsive.service';


@Component({
  selector: "app-locataire",
  templateUrl: "./locataire.component.html",
  styleUrls: ["./locataire.component.scss"],
})
export class LocataireComponent implements OnInit, OnDestroy {

  //Subscription
  rentingSubscription: Subscription;
  changeStatusSubscription: Subscription;
  invoiceSubscription: Subscription;
  paymentOfRentingExistSubsription: Subscription;
  public lazyLoad: boolean = false;
  public viewType: string = "list";
  public column: number = 4;
  public p: number = 1;


  statusChanged: boolean;
  rentingGetted: boolean;
  invoiceGetted: boolean;
  paymentOfRentingExistCreated: boolean;

 // displayedColumns: string[] = ['image', 'mark', 'dateStart', 'dateEnd', 'price', 'rest', 'status', 'date', 'owner', 'actions'];
  displayedColumns: string[] = ['image', 'mark', 'dateStart', 'dateEnd', 'price', 'status', 'date', 'actions'];

  dataSource!: MatTableDataSource<any>;

  @ViewChild(MatPaginator, {static: true}) paginator!: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort!: MatSort;
  
  
  user: any;
  rentings: any;

  afficheAddcars: boolean;
  afficheCoordonnees: boolean;
  affichepermis: boolean;

  injector: Injector;
  OpenWindow : any

  currentDate: string | null;

  affichecni: boolean = false;

  public currency: string;

  constructor(private rentingService: RentingService,
              public hostService: HostService,
              public appService:AppService,
              private authService: AuthService,
              private router: Router,
              private invoiceService: InvoiceService,
              private locationSmartService: LocationSmartService,
              private datePipe: DatePipe,
              private dialog: MatDialog,
              private extensionSmartService: ExtensionSmartService,
              private verifResponsiveService:VerifResponsiveService
            ) { }

  ngOnInit() {

    this.initProperty();
    this.verifResponsiveService.confirmResponsive().subscribe((data) => {
      console.log(data);
      this.viewType = data ? 'grid' : 'list';
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    if(window.innerWidth<=959)
    {
      this.viewType= 'grid';
    }
    else{
      this.viewType= 'list';
    }
  }

  private initProperty() {
      
    let res = this.authService.getUserOfLocalStorage();
    
    if(res.status) {

      this.user = JSON.parse(localStorage.getItem("user")!)

      //Nous vérifions si le profil de l'utilisateur est complet
      let verified = this.authService.verifieProfilOfUser();
      
      this.afficheAddcars = verified.afficheAddcars!;
      this.afficheCoordonnees = verified.afficheCoordonnees!;
      this.affichepermis = verified.affichepermis!

      //Check CNI
      this.affichecni = this.authService.checkCni();
 
      this.getRenting();

    } else {

      this.rentingGetted = false;

      this.router.navigate(['login']);

    }

    this.statusChanged = false;
    this.invoiceGetted = false;
    this.paymentOfRentingExistCreated = false;

    this.currentDate =  this.datePipe.transform(Date.now(), 'yyyy-MM-dd')
   
    this.currency = this.appService.getCurrency();
    
  }

  private getRenting() {

    this.rentingSubscription = this.rentingService.indexLodger(this.user.id).subscribe((rentings: any) => {
   
      this.rentingGetted = true;

      this.rentings = rentings.rentings
      
      this.dataSource = new MatTableDataSource(rentings.rentings);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort; 

    });

  }

  @HostListener('window:beforeunload', ['$event'])
  onWindowClose(event: Event) {
    window.open('','_target')?.close();
  }

  
  public changeStatus(renting: Object, value: string) {

    let result = this.locationSmartService.changeStatus(renting, value, 'lodger');

    if(result) {

      this.getRenting();

    }

  }

  /**
   * On selectionner le moyen de paiement avant de proceder au paiement
  */
  public choosePaymentMethod(idRenting: number) {

    const dialogRef = this.dialog.open(ChoosePaymentMethodComponent, {
      data: {
        id: idRenting,
        key: 'payment',
        for: 'renting'
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((response: any) => {

      this.getRenting();

    })

  }


  /**
   * Invoice of payment
   * @param idRenting 
   */
  public invoice(idRenting: number) {

    this.invoiceSubscription = this.invoiceService.invoiceRenting(idRenting, 'renting').subscribe((response: ArrayBuffer) => {
      
      this.invoiceGetted = true;
      
      download(response, 'application/pdf', 'facture'+idRenting+'.pdf');

    })
    
  }


  public viewRenting(idRenting: number) {

    let renting = this.rentings.find((res: any) => res.id == idRenting);
   
    let obj = {
      'idRenting': idRenting,
      'status': renting.renting_status,
      'message': renting.renting_message,
      'key': 'lodger',
    }
    
		this.appService.openDialogGalsenMessage(RentingMessageComponent, obj, 'theme-dialog');
			 
  } 

  applyFilter(event: Event) {

    const filterValue = (event.target as HTMLInputElement).value;

    this.dataSource.filter = filterValue.trim().toLowerCase();

  } 

  refresh() {
   
    this.getRenting();
    
  }

  /**
   * Prolonger la reservation
   * 
   * @param renting 
   */
  extension(renting: any) {

    // console.log(renting);

    this.extensionSmartService.OpenModalExtension(renting);

  }


  ngOnDestroy(): void {
    
    if(this.rentingGetted) {

      this.rentingSubscription.unsubscribe();

    }

    if(this.statusChanged) {

      this.changeStatusSubscription.unsubscribe();

    }

    if(this.invoiceGetted) {

      this.invoiceSubscription.unsubscribe();

    }

    if(this.paymentOfRentingExistCreated) {

      this.paymentOfRentingExistSubsription.unsubscribe();

    }

  }

  
  changeViewType(viewType:string)
  {
    this.viewType = viewType;
  }

}
